import { useState, useEffect } from "react";
import { useFetch } from "@/hooks/useFetch";
import api from "@/lib/api";
import { toast } from "sonner";
import { PageHeader } from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

export default function Settings() {
  const { data } = useFetch("/settings");
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (data) setForm(data); }, [data]);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    setSaving(true);
    try { await api.put("/settings", { ...form, default_tax_percent: Number(form.default_tax_percent) }); toast.success("Pengaturan disimpan"); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal (hanya Super Admin)"); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <PageHeader title="Pengaturan" subtitle="Konfigurasi perusahaan & kebijakan penagihan" />
      <Card className="p-6 max-w-2xl space-y-5">
        <div className="space-y-1.5"><Label>Nama Perusahaan</Label><Input value={form.company_name || ""} onChange={(e) => set("company_name", e.target.value)} data-testid="setting-company" /></div>
        <div className="space-y-1.5"><Label>PPN Default (%)</Label><Input type="number" value={form.default_tax_percent ?? ""} onChange={(e) => set("default_tax_percent", e.target.value)} data-testid="setting-tax" /></div>
        <Toggle label="Blokir kelebihan kuantitas terhadap PO" desc="Jika aktif, SJ melebihi PO diblokir; jika tidak, hanya diperingatkan." checked={!!form.over_po_block} onChange={(v) => set("over_po_block", v)} testId="setting-overpo" />
        <Toggle label="Tampilkan tarif pada lampiran untuk klien" desc="Menampilkan nilai tarif & subtotal pada Lampiran Status Perpanjangan versi klien." checked={!!form.show_rate_on_client_attachment} onChange={(v) => set("show_rate_on_client_attachment", v)} testId="setting-showrate" />
        <Toggle label="Closing Finance hanya setelah lunas" desc="Jika aktif, closing finance memerlukan seluruh invoice lunas." checked={!!form.closing_requires_full_payment} onChange={(v) => set("closing_requires_full_payment", v)} testId="setting-closingpay" />
        <Button onClick={save} disabled={saving} data-testid="settings-save-btn" className="bg-[#9333EA] hover:bg-[#7e22ce]">{saving ? "Menyimpan..." : "Simpan Pengaturan"}</Button>
      </Card>
    </div>
  );
}

function Toggle({ label, desc, checked, onChange, testId }) {
  return (
    <div className="flex items-start justify-between gap-4 border-t pt-4">
      <div><div className="font-medium text-sm">{label}</div><div className="text-xs text-muted-foreground">{desc}</div></div>
      <Switch checked={checked} onCheckedChange={onChange} data-testid={testId} />
    </div>
  );
}
